import React, { memo } from 'react'
import type { GanttTask, TimelineComputed } from './types'
import styles from './gantt.module.scss'
import { durationDays } from './utils/date'

export type TaskBarProps = {
  task: GanttTask
  rowIndex: number
  rowHeight: number
  barHeight: number
  tz: string
  timeline: TimelineComputed
  onClick?: (task: GanttTask) => void
}

const TaskBarComp = ({ task, rowIndex, rowHeight, barHeight, tz, timeline, onClick }: TaskBarProps) => {
  const y = rowIndex * rowHeight + Math.max(0, (rowHeight - barHeight) / 2)
  const startX = timeline.toX(task.start)
  const days = Math.max(1, durationDays(task.start, task.end, tz))
  const width = days * timeline.columnWidth

  const progress = Math.max(0, Math.min(100, task.progress ?? 0))
  const progressW = (width * progress) / 100

  if (task.milestone) {
    const cx = startX + timeline.columnWidth / 2
    const cy = y + barHeight / 2
    const size = Math.min(barHeight, timeline.columnWidth) * 0.6
    const points = [
      `${cx},${cy - size / 2}`,
      `${cx + size / 2},${cy}`,
      `${cx},${cy + size / 2}`,
      `${cx - size / 2},${cy}`,
    ].join(' ')

    return (
      <g onClick={() => onClick?.(task)} style={{ cursor: onClick ? 'pointer' : 'default' }}>
        <polygon className={styles.barMilestone} points={points} />
      </g>
    )
  }

  return (
    <g onClick={() => onClick?.(task)} style={{ cursor: onClick ? 'pointer' : 'default' }}>
      <rect className={styles.bar} x={startX} y={y} width={width} height={barHeight} fill={task.color || undefined} />
      {progress > 0 && <rect className={styles.barProgress} x={startX} y={y} width={progressW} height={barHeight} />}
    </g>
  )
}

export const TaskBar = memo(TaskBarComp)
